import React from "react";
import PropTypes from "prop-types";
import { RotateLeft as RotateLeftIcon } from "@material-ui/icons";
import {
  Card,
  Grid,
  Typography,
  IconButton,
  Tooltip,
  useMediaQuery,
} from "@material-ui/core";
import { useStyles } from "./applicationStyles";
import translate from "../../../../i18n/translate";
import { CopyButton } from "../../../common";
import theme from "theme";

const ApplicationCard = ({ name, appKey, action, actionToExecute, type }) => {
  const classes = useStyles();

  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const handleOnClick = () => {
    actionToExecute && actionToExecute(appKey);
  };

  const ActionIcon = () => (
    <>
      {type === "reset" ? (
        <Tooltip title={translate("common.reset")}>
          <IconButton
            aria-label={action}
            onClick={handleOnClick}
            size="small"
            className={classes.colorWhite}
          >
            <RotateLeftIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <CopyButton copy={appKey} className={classes.colorWhite} />
      )}
    </>
  );

  return (
    <div className={classes.appCard}>
      <Card className={classes.cardRoot} elevation={0}>
        <Grid container>
          <Grid
            item
            container
            xs={10}
            lg={12}
            justifyContent="space-between"
            direction="row"
            style={{ alignItems: "center" }}
          >
            <Grid item xs={12} lg={3}>
              <Typography
                variant="body2"
                align="left"
                className={classes.colorWhite}
              >
                {name}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={7}>
              <Typography
                variant="body2"
                noWrap
                align={matches ? "left" : "center"}
                className={classes.colorWhite}
              >
                {appKey}
              </Typography>
            </Grid>
            {!matches && (
              <Grid item xs={2} align="right">
                <ActionIcon />
              </Grid>
            )}
          </Grid>
          {matches && (
            <Grid container item xs={2} justifyContent="flex-end">
              <ActionIcon />
            </Grid>
          )}
        </Grid>
      </Card>
    </div>
  );
};

ApplicationCard.propTypes = {
  name: PropTypes.shape({}).isRequired,
  appKey: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  actionToExecute: PropTypes.func,
  type: PropTypes.string,
};

ApplicationCard.defaultProps = {
  type: "copy",
  actionToExecute: undefined,
};

export default ApplicationCard;
